import { z } from 'zod';

import {
  zodContractPayloadBaseSchema,
  zodContractResponseSchema,
  zodCreateContractItemPayloadSchema,
} from '../validations';

// Request payload schema for creating a contract
export const zodCreateContractPayloadSchema =
  zodContractPayloadBaseSchema.extend({
    // Null when this create is not tied to an import job.
    importJobId: z.uuid().nullish(),
    items: z.array(zodCreateContractItemPayloadSchema).min(1),
  });

// Response schema for created contract (re-export from shared)
export { zodContractResponseSchema as zodCreateContractResponseSchema };
